import { render, staticRenderFns } from "./jsycDetailPopup.vue?vue&type=template&id=99593556&"
import script from "./jsycDetailPopup.vue?vue&type=script&lang=js&"
export * from "./jsycDetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./jsycDetailPopup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports